import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITION_RESULT_WINNER_REQUEST = 'POST_COMPETITION_RESULT_WINNER_REQUEST';
export const COMPETITION_RESULT_WINNER_FAILURE = 'POST_COMPETITION_RESULT_WINNER_FAILURE';
export const COMPETITION_RESULT_WINNER_SUCCESS = 'POST_COMPETITION_RESULT_WINNER_SUCCESS';

/**
 * Interactive bracket: declare the winner of the fight the result row
 * belongs to. The backend advances the winner, feeds the third-place
 * fight, clears invalidated later rounds and returns the WHOLE re-derived
 * category draw — the reducer swaps the category rows for the response.
 *
 * `victoryClass` — how an MSAC Б-1…Б-4/Б-7 bout was won (clean, on_points,
 * slight_advantage): the penalty points both sides take (21 Oct 2026). Sent
 * only when given; the backend requires it for those categories.
 */
export const selectFightWinner = (resultId, winnerParticipantId, competition, category, victoryClass = null) => {
    return function(dispatch) {
        dispatch(winnerRequest());
        const body = victoryClass ? { winnerParticipantId, victoryClass } : { winnerParticipantId };
        return axios(apiRequestOptions(apiPath.COMPETITION_RESULT.WINNER, body, {params: {id: resultId}}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(winnerSuccess(response.data, competition, category));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(winnerFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const winnerRequest = () => ({type: COMPETITION_RESULT_WINNER_REQUEST});

const winnerFailure = error => ({type: COMPETITION_RESULT_WINNER_FAILURE, error});

const winnerSuccess = (results, competition, category) => ({
    type: COMPETITION_RESULT_WINNER_SUCCESS,
    results,
    competition,
    category,
});
